/* Kalme — moteur d'animation de la landing produit.
   Tout est progressif : sans JS ou en reduced-motion, le contenu reste lisible. */
(function () {
  'use strict';

  if (window.__kalmeLp) return;
  window.__kalmeLp = true;

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var supportsIO = 'IntersectionObserver' in window;

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  /* ---------- Source de défilement ----------
     Horizon fait défiler `.page-wrapper` au-dessus de 990px, et le document
     en dessous. Écouter `window` uniquement ne capterait rien sur desktop. */

  var squeeze = window.matchMedia('(min-width: 990px)');

  function scrollTarget() {
    if (squeeze.matches) {
      var wrapper = document.querySelector('.page-wrapper');
      if (wrapper) return wrapper;
    }
    return document;
  }

  var scrollReaders = [];
  var scrollBoundTo = null;
  var scrollTicking = false;

  function runScrollReaders() {
    scrollTicking = false;
    for (var i = 0; i < scrollReaders.length; i++) scrollReaders[i]();
  }

  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(runScrollReaders);
  }

  function bindScroll() {
    var target = scrollTarget();
    if (scrollBoundTo === target) return;
    if (scrollBoundTo) scrollBoundTo.removeEventListener('scroll', onScroll);
    target.addEventListener('scroll', onScroll, { passive: true });
    scrollBoundTo = target;
  }

  function watchScroll(reader) {
    scrollReaders.push(reader);
    bindScroll();
    if (!window.__kalmeScrollBound) {
      window.__kalmeScrollBound = true;
      window.addEventListener('resize', onScroll, { passive: true });
      var rebind = function () {
        bindScroll();
        onScroll();
      };
      if (squeeze.addEventListener) squeeze.addEventListener('change', rebind);
      else if (squeeze.addListener) squeeze.addListener(rebind);
    }
    reader();
  }

  function ioRoot() {
    if (squeeze.matches) {
      return document.querySelector('.page-wrapper') || null;
    }
    return null;
  }

  /* ---------- Révélation générique ---------- */

  function initReveal(root) {
    var els = root.querySelectorAll('[data-kr]:not([data-kr-ready])');
    if (!els.length) return;

    if (reduced || !supportsIO) {
      each(els, function (el) {
        el.setAttribute('data-kr-ready', '');
        el.classList.add('kr-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('kr-in');
          io.unobserve(entry.target);
        });
      },
      { root: ioRoot(), rootMargin: '0px 0px -8% 0px', threshold: 0 }
    );

    each(els, function (el) {
      el.setAttribute('data-kr-ready', '');
      var delay = el.getAttribute('data-kr-delay');
      if (delay) el.style.setProperty('--kr-delay', parseInt(delay, 10) + 'ms');
      io.observe(el);
    });
  }

  /* ---------- Titres animés mot à mot ---------- */

  function initWords(root) {
    each(root.querySelectorAll('[data-kalme-words]:not([data-words-ready])'), function (el) {
      el.setAttribute('data-words-ready', '');
      if (reduced) return;

      var words = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      el.classList.add('lp-words');
      words.forEach(function (word, i) {
        var span = document.createElement('span');
        span.className = 'lp-word';
        span.style.setProperty('--i', i);
        span.textContent = word;
        el.appendChild(span);
        if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
      });
    });
  }

  /* ---------- Scrollytelling : visuel collant + étapes ---------- */

  function initScrolly(root) {
    each(root.querySelectorAll('[data-kalme-scrolly]:not([data-scrolly-ready])'), function (scope) {
      scope.setAttribute('data-scrolly-ready', '');

      var steps = scope.querySelectorAll('[data-scrolly-step]');
      var frames = scope.querySelectorAll('[data-scrolly-frame]');
      var bar = scope.querySelector('[data-scrolly-progress]');
      if (!steps.length || !frames.length) return;

      function activate(index) {
        each(steps, function (step, i) {
          step.classList.toggle('is-active', i === index);
        });
        each(frames, function (frame, i) {
          var on = i === index;
          frame.classList.toggle('is-active', on);
          frame.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        if (bar) {
          bar.style.setProperty('--progress', (index + 1) / steps.length);
        }
      }

      activate(0);

      if (reduced || !supportsIO) {
        scope.classList.add('is-static');
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var index = parseInt(entry.target.getAttribute('data-scrolly-step'), 10);
            if (!isNaN(index)) activate(index);
          });
        },
        { root: ioRoot(), rootMargin: '-45% 0px -45% 0px', threshold: 0 }
      );

      each(steps, function (step) {
        io.observe(step);
      });
    });
  }

  /* ---------- Jauges de compétences ---------- */

  function initBars(root) {
    var bars = root.querySelectorAll('[data-kalme-bar]:not([data-bar-ready])');
    if (!bars.length) return;

    function fill(el) {
      var value = parseFloat(el.getAttribute('data-kalme-bar')) || 0;
      el.style.setProperty('--value', String(Math.max(0, Math.min(100, value))));
      el.classList.add('is-filled');
    }

    if (reduced || !supportsIO) {
      each(bars, function (el) {
        el.setAttribute('data-bar-ready', '');
        fill(el);
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          fill(entry.target);
          io.unobserve(entry.target);
        });
      },
      { root: ioRoot(), threshold: 0.4 }
    );

    each(bars, function (el) {
      el.setAttribute('data-bar-ready', '');
      io.observe(el);
    });
  }

  /* ---------- Compteurs ---------- */

  function initCounters(root) {
    var nodes = root.querySelectorAll('[data-kalme-count]:not([data-count-ready])');
    if (!nodes.length) return;

    function run(el) {
      var target = parseFloat(el.getAttribute('data-kalme-count'));
      if (isNaN(target)) return;
      var decimals = (el.getAttribute('data-kalme-count').split('.')[1] || '').length;
      if (reduced) {
        el.textContent = target.toFixed(decimals).replace('.', ',');
        return;
      }
      var duration = 1100;
      var start = performance.now();
      function tick(now) {
        var p = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(decimals).replace('.', ',');
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    if (!supportsIO) {
      each(nodes, function (el) {
        el.setAttribute('data-count-ready', '');
        run(el);
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          run(entry.target);
          io.unobserve(entry.target);
        });
      },
      { root: ioRoot(), threshold: 0.6 }
    );

    each(nodes, function (el) {
      el.setAttribute('data-count-ready', '');
      io.observe(el);
    });
  }

  /* ---------- Parallaxe douce ---------- */

  var parallaxItems = [];

  function readParallax() {
    var vh = window.innerHeight;
    parallaxItems.forEach(function (item) {
      var rect = item.el.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) return;
      var center = rect.top + rect.height / 2;
      var offset = (center - vh / 2) / vh;
      item.el.style.transform = 'translate3d(0,' + (offset * item.speed * -100).toFixed(2) + 'px,0)';
    });
  }

  function initParallax(root) {
    if (reduced) return;
    var els = root.querySelectorAll('[data-kalme-parallax]:not([data-parallax-ready])');
    if (!els.length) return;

    each(els, function (el) {
      el.setAttribute('data-parallax-ready', '');
      parallaxItems.push({
        el: el,
        speed: parseFloat(el.getAttribute('data-kalme-parallax')) || 0.15,
      });
    });

    if (!window.__kalmeParallaxBound) {
      window.__kalmeParallaxBound = true;
      watchScroll(readParallax);
    } else {
      readParallax();
    }
  }

  /* ---------- Progression de scroll locale (0 → 1) ---------- */

  var progressItems = [];

  function readProgress() {
    var vh = window.innerHeight;
    progressItems.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var total = rect.height + vh;
      var seen = vh - rect.top;
      var p = Math.max(0, Math.min(1, seen / total));
      el.style.setProperty('--scroll-progress', p.toFixed(4));
    });
  }

  function initProgress(root) {
    var els = root.querySelectorAll('[data-kalme-progress]:not([data-progress-ready])');
    if (!els.length) return;

    each(els, function (el) {
      el.setAttribute('data-progress-ready', '');
      progressItems.push(el);
    });

    if (!window.__kalmeProgressBound) {
      window.__kalmeProgressBound = true;
      watchScroll(readProgress);
    } else {
      readProgress();
    }
  }

  /* ---------- Barre d'achat collante ---------- */

  function initStickyBar(root) {
    each(root.querySelectorAll('[data-kalme-stickybar]:not([data-sticky-ready])'), function (bar) {
      bar.setAttribute('data-sticky-ready', '');
      var afterId = bar.getAttribute('data-sticky-after');
      var untilId = bar.getAttribute('data-sticky-until');
      var afterEl = afterId ? document.getElementById(afterId) : null;
      var untilEl = untilId ? document.getElementById(untilId) : null;
      var section = bar.closest('.shopify-section');

      // Sortir la barre du flux Shopify : sinon elle reste en bas du document
      // et le fixed est cassé par les wrappers de section.
      var host = document.querySelector('.page-wrapper') || document.body;
      if (bar.parentElement !== host) host.appendChild(bar);
      if (section && !section.querySelector('[data-kalme-stickybar]')) {
        section.style.display = 'none';
      }

      function syncSticky() {
        if (!afterEl) {
          bar.classList.add('is-visible');
          return;
        }

        var topEdge = 0;
        var bottomEdge = window.innerHeight;
        var rootEl = ioRoot();
        if (rootEl) {
          var rootRect = rootEl.getBoundingClientRect();
          topEdge = rootRect.top;
          bottomEdge = rootRect.bottom;
        }

        var pastSkills = afterEl.getBoundingClientRect().top < topEdge + 48;
        // Dès que l'offre arrive dans le viewport, on range la barre
        // (et on la garde rangée en dessous, FAQ / footer compris).
        var reachedOffer = untilEl
          ? untilEl.getBoundingClientRect().top < bottomEdge - 24
          : false;

        bar.classList.toggle('is-visible', pastSkills && !reachedOffer);
      }

      watchScroll(syncSticky);
      syncSticky();
    });
  }

  /* ---------- Points chauds ---------- */

  function initHotspots(root) {
    each(root.querySelectorAll('[data-kalme-hotspots]:not([data-hotspots-ready])'), function (scope) {
      scope.setAttribute('data-hotspots-ready', '');
      var dots = scope.querySelectorAll('[data-hotspot]');

      each(dots, function (dot) {
        dot.addEventListener('click', function () {
          var open = dot.classList.contains('is-open');
          each(dots, function (other) {
            other.classList.remove('is-open');
            other.setAttribute('aria-expanded', 'false');
          });
          if (!open) {
            dot.classList.add('is-open');
            dot.setAttribute('aria-expanded', 'true');
          }
        });
      });

      document.addEventListener('click', function (event) {
        if (scope.contains(event.target)) return;
        each(dots, function (dot) {
          dot.classList.remove('is-open');
          dot.setAttribute('aria-expanded', 'false');
        });
      });
    });
  }

  /* ---------- Vidéo : lecture uniquement quand visible ---------- */

  function initVideos(root) {
    each(root.querySelectorAll('[data-kalme-video]:not([data-video-ready])'), function (video) {
      video.setAttribute('data-video-ready', '');
      if (reduced) return;

      if (!supportsIO) {
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { root: ioRoot(), threshold: 0.25 }
      );
      io.observe(video);
    });
  }

  /* ---------- Bandeau défilant ---------- */

  function initMarquee(root) {
    each(root.querySelectorAll('[data-kalme-marquee]:not([data-marquee-ready])'), function (track) {
      track.setAttribute('data-marquee-ready', '');
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-kalme-marquee');
      track.parentNode.appendChild(clone);
    });
  }

  /* ---------- Après ajout : CTA « Ouvrir le panier » ---------- */

  var openCartArmed = false;

  function openCartDrawer(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    if (window.Shopify && Shopify.actions && typeof Shopify.actions.openCart === 'function') {
      Shopify.actions.openCart();
      return;
    }

    window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
  }

  function armOpenCartButton(btn) {
    if (!btn || btn.dataset.kalmeOpenCart === 'true') return;

    var label =
      btn.getAttribute('data-kalme-open-cart-label') ||
      (btn.closest('[data-kalme-open-cart-label]') &&
        btn.closest('[data-kalme-open-cart-label]').getAttribute('data-kalme-open-cart-label')) ||
      'Ouvrir le panier';

    btn.dataset.kalmeOpenCart = 'true';
    btn.removeAttribute('data-added');
    btn.type = 'button';
    btn.removeAttribute('name');
    btn.disabled = false;
    btn.classList.add('is-open-cart');

    var icon = btn.querySelector('.add-to-cart-icon');
    var added = btn.querySelector('.add-to-cart__added');
    while (btn.firstChild) btn.removeChild(btn.firstChild);
    if (icon) btn.appendChild(icon);
    btn.appendChild(document.createTextNode(' ' + label + ' '));
    if (added) {
      added.setAttribute('aria-hidden', 'true');
      btn.appendChild(added);
    }

    btn.addEventListener('click', openCartDrawer);
  }

  function armAllOpenCartButtons() {
    openCartArmed = true;
    each(
      document.querySelectorAll(
        '.kalme-offer__submit, .kalme-stickybar__submit'
      ),
      armOpenCartButton
    );
  }

  function initOpenCartCta() {
    if (initOpenCartCta.ready) return;
    initOpenCartCta.ready = true;

    document.addEventListener('shopify:cart:lines-update', function (event) {
      var action = event.action || (event.detail && event.detail.action);
      if (action && action !== 'add') return;
      // Laisse le checkmark Horizon ~0,8s, puis bascule le label.
      window.setTimeout(armAllOpenCartButtons, 850);
    });

    // Si un formulaire Kalme est re-soumis alors que le bouton est armé, ouvrir le panier.
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.closest) return;
        var btn = form.querySelector(
          '.kalme-offer__submit[data-kalme-open-cart="true"], .kalme-stickybar__submit[data-kalme-open-cart="true"]'
        );
        if (!btn) return;
        event.preventDefault();
        openCartDrawer(event);
      },
      true
    );

    if (openCartArmed) armAllOpenCartButtons();
  }

  /* ---------- Boot ---------- */

  function boot(root) {
    var scope = root || document;
    initWords(scope);
    initReveal(scope);
    initScrolly(scope);
    initBars(scope);
    initCounters(scope);
    initParallax(scope);
    initProgress(scope);
    initStickyBar(scope);
    initHotspots(scope);
    initVideos(scope);
    initMarquee(scope);
    initOpenCartCta();
    if (openCartArmed) armAllOpenCartButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  // Rejoue l'init quand l'éditeur de thème recharge une section.
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
